module.exports = __webpack_public_path__ + "uy.f972eab7b3aa16b6235e.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/uy.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/uy.svg
// module chunks = styles